// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__-wZxR","resendInfoText":"OnGoingPaymentBox_resendInfoText__3br13"};